import type { ReactNode } from "react";
import type { TranslationKey } from "../../lib/i18n";
import { useConfig } from "../../state/config-context";

export interface TabDefinition {
  id: string;
  labelKey: TranslationKey;
}

export function Tabs({
  tabs,
  active,
  onChange,
}: {
  tabs: TabDefinition[];
  active: string;
  onChange: (id: string) => void;
}): ReactNode {
  const { t } = useConfig();
  return (
    <div className="tabs" role="tablist" aria-label={t("crm.common.tabs")}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          id={`tab-${tab.id}`}
          aria-selected={active === tab.id}
          aria-controls={`panel-${tab.id}`}
          className={`tabs__tab${active === tab.id ? " is-active" : ""}`}
          onClick={() => onChange(tab.id)}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );
}
